import { Alert, Box } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  fullPage?: boolean
}

export const Error: FunctionComponent<Props> = ({ fullPage }) => {
  if (fullPage)
    return (
      <PageWrapper>
        <ErrorElement />
      </PageWrapper>
    )
  return <ErrorElement />
}

export const ErrorElement = () => {
  const { t } = useTranslation()
  return (
    <Box>
      <Alert severity="error">{t('failedToCreate')}</Alert>
    </Box>
  )
}
